import { c as _c } from "react/compiler-runtime";
import { IcoImages24 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import { HeaderTitle, NavigationHeader } from '@/idv/components';
import { getLogger } from '@/idv/utils';
import type { CameraErrorCause } from '../../types';
import getCameraErrorCause from '../../utils/get-camera-error-cause';
import { getMediaStream } from '../camera/hooks/use-user-media';
type CameraAccessRequestProps = {
  onClose: () => void;
  onCameraError: (cause: CameraErrorCause) => void;
  onCameraAccessDenied: () => void;
  onSuccess: () => void;
};
const {
  logWarn
} = getLogger({
  location: 'camera-access-request'
});
const CameraAccessRequest = t0 => {
  const $ = _c(49);
  const {
    onClose,
    onCameraError,
    onCameraAccessDenied,
    onSuccess
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] !== onCameraAccessDenied || $[2] !== onCameraError || $[3] !== onSuccess) {
    t2 = async () => {
      ;
      try {
        const stream = await getMediaStream({
          video: true
        });
        stream.getTracks().forEach(_temp);
        onSuccess();
      } catch (t3) {
        const err = t3;
        logWarn("Error getting media stream", err);
        const cause = getCameraErrorCause(err);
        if (cause === "permission-denied") {
          onCameraAccessDenied();
        } else {
          onCameraError(cause);
        }
      }
    };
    $[1] = onCameraAccessDenied;
    $[2] = onCameraError;
    $[3] = onSuccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleAllowAccess = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 1,
      transition: {
        duration: 0.3
      }
    };
    t5 = {
      opacity: 0
    };
    t6 = <style>{"\n          @media (max-width: 899px) {\n            #footprint-footer { display: none; }\n            #idv-body-content-container > div { padding-bottom: 0; }\n          }\n        "}</style>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onClose) {
    t7 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: onClose
    }} />;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t) {
    t8 = t(_temp2);
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <HeaderTitle title={t8} display="flex" flexDirection="column" />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="shrink-0"><IcoImages24 color="primary" /></div>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <p className="text-label-2 text-primary"><Trans ns="idv" i18nKey={_temp3} components={{
        underlined: <span className="underline" />
      }} /></p>;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t) {
    t12 = t(_temp4);
    $[17] = t;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12) {
    t13 = <div className="flex gap-3 items-start">{t10}<div>{t11}<p className="text-body-2 text-tertiary">{t12}</p></div></div>;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="shrink-0"><IcoImages24 color="primary" /></div>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="text-label-2 text-primary"><Trans ns="idv" i18nKey={_temp5} components={{
        underlined: <span className="underline" />
      }} /></p>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t) {
    t16 = t(_temp6);
    $[23] = t;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t16) {
    t17 = <p className="text-body-2 text-tertiary">{t16}</p>;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t) {
    t18 = t(_temp7);
    $[27] = t;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t18) {
    t19 = <p className="text-label-2 text-primary">{t18}</p>;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t17 || $[32] !== t19) {
    t20 = <div className="flex gap-3 items-start">{t14}<div>{t15}{t17}{t19}</div></div>;
    $[31] = t17;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t13 || $[35] !== t20) {
    t21 = <div className="flex flex-col gap-4 w-full">{t13}{t20}</div>;
    $[34] = t13;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t) {
    t22 = t(_temp8);
    $[37] = t;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== handleAllowAccess || $[40] !== t22) {
    t23 = <Button fullWidth={true} onClick={handleAllowAccess} testID="allow-access" size="large">{t22}</Button>;
    $[39] = handleAllowAccess;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t21 || $[43] !== t23 || $[44] !== t9) {
    t24 = <div className="flex flex-col items-center flex-1 gap-6">{t9}{t21}{t23}</div>;
    $[42] = t21;
    $[43] = t23;
    $[44] = t9;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t24 || $[47] !== t7) {
    t25 = <motion.div className="flex flex-col flex-1 h-full" initial={t3} animate={t4} exit={t5}>{t6}{t7}{t24}</motion.div>;
    $[46] = t24;
    $[47] = t7;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
};
export default CameraAccessRequest;
function _temp(track) {
  track.stop();
}
function _temp2($) {
  return $["access-camera"];
}
function _temp3($_0) {
  return $_0["document-flow"]["how-you-will-use-this"];
}
function _temp4($_1) {
  return $_1["docs-and-or-selfie"];
}
function _temp5($_2) {
  return $_2["document-flow"]["how-we-will-use-this"];
}
function _temp6($_3) {
  return $_3["key-needed-for-verification"];
}
function _temp7($_4) {
  return $_4["no-camera-access"];
}
function _temp8($_5) {
  return $_5["allow-access"];
}